<template>
  <div :class="$style.root">
    <SharedExhibitionsHeaderComponent
      :page="page"
      :class="$style.header"
    >
      <div
        v-if="page?.linkTopPage?.id"
        :class="$style.linkTopPageContainer"
      >
        <SharedLinkComponent
          :link="page?.linkTopPage"
          :class="$style.linkTopPage"
        >
          {{ page?.linkTopPage?.label }}
        </SharedLinkComponent>
      </div>
    </SharedExhibitionsHeaderComponent>

    <LayoutGridComponent
      v-if="getAttributes(page?.coverImage) || page?.images?.data"
      :class="$style.grid"
    >
      <CoreImageComponent
        v-if="getAttributes(page?.coverImage)"
        :image="getAttributes(page?.coverImage)"
        :class="$style.coverImage"
      />
      <PagesExhibitionsSlugImagesComponent
        v-if="page?.images?.data"
        :images="page?.images?.data"
      />
    </LayoutGridComponent>
    <CoreBlocksComponent :blocks="page?.blocks"/>
    <SharedEventsRelatedComponent :page="page" />
    <SharedRelatedComponent :page="page" />
    <SharedPressComponent :page="page" :includeLabel="false" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const getAttributes = baseStrapiGetAttributes
const page = baseStrapiGetAttributes(props.data)

</script>

<style module>
.root {
}

.header {
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.grid {
  background-color: var(--color--background);
  --base--image--object-fit: cover;
  --base--image--max-aspect-ratio: 3 / 2;

  margin-bottom: calc(var(--unit--vertical) * 2);
}

.coverImage {
  --base--image--aspect-ratio: auto;
}

.linkTopPageContainer {
  margin-top: var(--lh);
  grid-column: 1 / -1;

  display: flex;
  justify-content: flex-end;
}

.linkTopPage {
  composes: font-helvetica font-size-small button from global;

  background-color: var(--color--primary);
  color: var(--color--background);

  border-color: var(--color--primary);
}

.linkTopPage:hover {
  background-color: var(--color--background);
  color: var(--color--primary);
}
</style>
